import React, { Fragment } from 'react'
import cn from 'classnames'
import { Download32, InformationFilled32 } from '@carbon/icons-react'
import Button from '../../Button'
import { InlineLoading } from '../../Loading'
import AmchartsWrapper from '../../Charts/AmchartsWrapper'
import { isUndefined } from 'lodash'
import '../index.scss'

const Chart = (props) => {
  const {
    type,
    headerTitle,
    chartTitle,
    exportEnabled = false,
    className,
    isLoading = false,
    isError = false,
    isDataEmpty = false,
    noDataLabel = 'NO_DATA',
    infoButton = {}
  } = props

  const { enabled: infoButtonEnabled = false, message: infoButtonMessage } =
    infoButton
  const showInfoButton = infoButtonEnabled && !!infoButtonMessage

  return (
    <div
      className={cn('kpi-chart-container kpi-chart-body', {
        [className]: !isUndefined(className)
      })}
    >
      {(headerTitle || exportEnabled || showInfoButton) && (
        <div
          className={cn('kpi-chart-header', {
            'kpi-chart-header--no-title': !headerTitle
          })}
        >
          {headerTitle && (
            <div className='kpi-chart-header__title'>{headerTitle}</div>
          )}
          <div className='kpi-chart-header__actions'>
            {showInfoButton && (
              <Button
                hasIconOnly
                className={cn(
                  'kpi-chart-header__actions__btn',
                  'kpi-chart-header__actions__btn--info',
                  {
                    'kpi-chart-header__actions__btn--last': !exportEnabled,
                    'kpi-chart-header__actions__btn--first': exportEnabled
                  }
                )}
                renderIcon={InformationFilled32}
                iconDescription={infoButtonMessage}
                tooltipPosition='bottom'
              />
            )}
            {exportEnabled && (
              <Button
                hasIconOnly
                className='kpi-chart-header__actions__btn kpi-chart-header__actions__btn--export'
                renderIcon={Download32}
                onClick={() => {}}
                iconDescription='Download'
                tooltipPosition='bottom'
              />
            )}
          </div>
        </div>
      )}
      <div
        className={cn('kpi-chart-box-content', {
          'status-box': isLoading || isError || isDataEmpty
        })}
      >
        {isLoading ? (
          <InlineLoading />
        ) : isError || isDataEmpty ? (
          noDataLabel
        ) : (
          <Fragment>
            {type === 'AMCHART_PIE' && !chartTitle ? null : (
              <div className='kpi-chart-title'>
                <h5>{chartTitle}</h5>
              </div>
            )}
            <div className={cn('kpi-chart')}>
              <AmchartsWrapper {...props} />
            </div>
          </Fragment>
        )}
      </div>
    </div>
  )
}

export default Chart
